module.exports = __webpack_public_path__ + "static/media/in_progress_orange.263265d3.svg";